import React from 'react';
import { Dialog, DialogContent, DialogClose } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/PcButton';
import { useNavigate } from 'react-router-dom';

const NoMembershipDialog = ({ open, onOpenChange }) => {
  const navigate = useNavigate();
  const handleMembershipPage = () => {
    // 멤버십 가입 페이지로 이동
    navigate('/more/membership');
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent noCloseBtn className="w-[320px] p-[30px]">
        <div className="flex flex-col items-start  ">
          <div className="text-gr-900 Title3S18">모니터링 상품 개수가 초과됐어요</div>
          <div className=" mt-[4px] text-gr-700 Body5M14">
            최대 2개의 상품까지 모니터링 할 수 있어요
            <br />
            멤버십을 가입할까요?
          </div>
          <div className="mt-[20px] flex w-full gap-3">
            <DialogClose asChild>
              <Button variant="muted" className="h-[44px] flex-1">
                닫기
              </Button>
            </DialogClose>
            <Button variant="default" className="flex-1" onClick={handleMembershipPage}>
              멤버십 가입
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NoMembershipDialog;
